package com.essntl.core.settings.domain.model.configuration

import com.essntl.core.settings.data.supabase.configuration.ConfigurationCurrencyDto

data class ConfigurationCurrencyModel(
    val allowed: List<String>,
    val default: String,
    val costDefault: String,

) {
    fun toDto(): ConfigurationCurrencyDto =
        ConfigurationCurrencyDto(
            allowed = allowed,
            default = default,
            costDefault = costDefault,
        )
}
